import { useState } from 'react';
import { ChevronDown } from 'lucide-react';

export default function FAQAccordion({ items }) {
  const [openId, setOpenId] = useState(null);

  const toggleAccordion = (id) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <div className="space-y-3">
      {items.map((item) => (
        <div
          key={item.id}
          className="border border-slate-200 rounded-lg overflow-hidden transition-all duration-200 hover:border-blue-300 hover:shadow-md"
        >
          <button
            onClick={() => toggleAccordion(item.id)}
            className="w-full px-6 py-4 flex items-center justify-between bg-white hover:bg-slate-50 transition-colors text-left"
            aria-expanded={openId === item.id}
            aria-controls={`answer-${item.id}`}
          >
            <span className="font-semibold text-slate-900 text-lg">
              {item.question}
            </span>
            <ChevronDown
              size={22}
              className={`text-blue-500 transition-transform duration-300 flex-shrink-0 ml-4 ${
                openId === item.id ? 'rotate-180' : ''
              }`}
            />
          </button>

          {openId === item.id && (
            <div
              id={`answer-${item.id}`}
              className="px-6 py-5 bg-slate-50 border-t border-slate-200 text-slate-700 leading-relaxed"
            >
              {item.answer}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}